import React, { useEffect } from "react";
import { FiChevronRight } from "react-icons/fi";
import { useState } from "react";
import axios from "axios";
import config from "../../../settings/config";
import BasketChangeQuantity from "../shoppingConfigs/BasketChangeQuantity";
import { getGityShopCategoriesService } from "../products/services";
import Empty from "../../../base/features/blocks/Empty";
import Image from "../../../base/features/micro/Image";
import Spinner from "../../../base/features/micro/Spinner";

const NewShopCategory = () => {
  const [sortIndex, setSortIndex] = useState(1);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categoriesList, setCategoriesList] = useState([]);

  const shopUid = window.location.pathname.split("/")[2];
  const url = config.baseUrl + `v1/shops/${shopUid}/categories`;

  axios.defaults.headers.common["Authorization"] = localStorage.getItem(
    `${window.location.hostname}_token`
  );

  const handleEditShoppingConfigs = async () => {
    setLoading(true);
    await axios
      .post(url, {
        name: title,
        primary: selectedCategory?.uid,
        index: sortIndex,
      })
      .then((res) => {
        window.history.back();
      })
      .catch((err) => console.log(err));
    setLoading(false);
  };

  const getGityShopCategories = async () => {
    setLoading(true);
    getGityShopCategoriesService(shopUid)
      .then((items) => {
        setCategoriesList(items?.gity_categories);
      })
      .catch((err) => console.log(err));
    setLoading(false);
  };

  useEffect(() => {
    getGityShopCategories();
  }, []);

  return (
    <div className="container-fluid">
      <section>
        <header
          className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0", zIndex: "99999" }}
        >
          <div className="col-auto align-self-center px-0">
            <FiChevronRight
              size="26"
              className=""
              onClick={() => window.history.back()}
            />
          </div>
          <div className="col text-center align-self-center px-0">
            <h1 className="fs-5 fw-bold mb-0">افزودن دسته بندی اختصاصی</h1>
          </div>
          <div className="col-auto text-center align-self-center px-0">
            <button
              onClick={() => handleEditShoppingConfigs()}
              className="btn fs-6 p-0 fw-bold mb-0 color-main disabled-color"
              disabled={selectedCategory === "" || title === ""}
            >
              ذخیره
            </button>
          </div>
        </header>
        <body style={{ marginTop: "50px", padding: "5%" }}>
          <input
            type="text"
            className="rounded14 border p-3 w-100 mt-4"
            value={title}
            placeholder="عنوان"
            onChange={(e) => setTitle(e?.target?.value)}
          />
          <div className="fs-6 fw-bold mt-4">ترتیب نمایش به کاربر</div>
          <BasketChangeQuantity
            loading={loading}
            setValue={setSortIndex}
            value={sortIndex}
          />
          <div className="fs-6 fw-bold mt-4">دسته بندی گیتی مارکت</div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="row mx-0 p-3">
              {categoriesList.map((category, c) =>
                categoriesList.length === 0 ? (
                  <Empty text="دسته بندی موجود نمی باشد" key={c} />
                ) : (
                  <div
                    className={
                      "col-4 px-0 my-3 py-1 rounded14 text-center " +
                      (selectedCategory &&
                      category?.uid === selectedCategory?.uid
                        ? "border-color-main"
                        : "")
                    }
                    onClick={() => setSelectedCategory(category)}
                    key={c}
                  >
                    <Image
                      imageUri={category?.icon && category?.icon?.icon_128}
                      imgClassName="w-50 d-block mx-auto"
                      extraClassName="w-50 d-block rounded14 p-2 mx-auto bg-secondary"
                    />
                    <p className="mb-0 mt-2">{category?.title}</p>
                  </div>
                )
              )}
            </div>
          )}
        </body>
      </section>
    </div>
  );
};

export default NewShopCategory;
